import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Pagination, Radio, Stack, Switch, TextField, Grow, Grid } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToLogin, goToPatients, goToUsers } from "../../../routes/Coordinator";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import useForm from "../../../hooks/useForm";
import axios from "axios";
import { useEffect } from "react";
import InputMask from 'react-input-mask';

const products = [
  {
    id: "1",
    name: "Sunil Joshi",
    post: "Web Designer",
    pname: "Elite Admin",
    priority: "Low",
    pbg: "primary.main",
    budget: "3.9",
  },
  {
    id: "2",
    name: "Andrew McDownland",
    post: "Project Manager",
    pname: "Real Homes WP Theme",
    priority: "Medium",
    pbg: "secondary.main",
    budget: "24.5",
  },
  {
    id: "3",
    name: "Christopher Jamil",
    post: "Project Manager",
    pname: "MedicalPro WP Theme",
    priority: "High",
    pbg: "error.main",
    budget: "12.8",
  },
  {
    id: "4",
    name: "Nirav Joshi",
    post: "Frontend Engineer",
    pname: "Hosting Press HTML",
    priority: "Critical",
    pbg: "success.main",
    budget: "2.4",
  },
];
const filters = [
  {
    value: "name",
    label: "Nome",
  },
  {
    value: "email",
    label: "Email",
  },
  {
    value: "permition",
    label: "Permissão",
  },
];

function UseQuery() {
  return new URLSearchParams(window.location.search)
}

const PatientRecord = () => {
  const [name, setName] = useState("")
  const [cpf, setCpf] = useState("")
  const [payer_name, setPayerName] = useState("")
  const [payer_cpf, setPayer_cpf] = useState("")
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();

  const icon = (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={12} lg={6}>
        <TextField
          name={"payer_name"}
          onChange={(e) => setPayerName(e.target.value)}
          value={payer_name}
          label={"Nome do pagador"}
          variant={"outlined"}
          required
          type={"payer_name"}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={12} lg={6}>
        <InputMask
          name={"payer_cpf"}
          onChange={(e) => setPayer_cpf(e.target.value)}
          value={payer_cpf}
          type={"text"}
          required
          mask="999.999.999-99"
          disabled={false}
          variant={"outlined"}
          fullWidth

        >
          {() => <TextField fullWidth label={"CPF do Pagador"} />}
        </InputMask>
      </Grid>
    </Grid>
  );

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  const save = () => {
    let id = UseQuery().get("id")

    if (!id) {
      newPatient()
    } else {
      EditPatient()
    }
  }
  const newPatient = () => {

    if (checked === false) {
      axios.post(`${process.env.REACT_APP_BASE_URL}/patients`, { patient: { name, cpf } },
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "token-type": localStorage.getItem("token-type"),
            "expiry": localStorage.getItem("expiry"),
            "uid": localStorage.getItem("uid"),
            "Content-Type": "application/json"

          }
        })
        .then((resposta) => {
          alert("Paciente cadastrado com sucesso!")
          goToPatients(navigate)
        })
        .catch((erro) => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
        }
        )
    } else {
      newPayer()
    }
  }
  const newPayer = () => {
    axios.post(`${process.env.REACT_APP_BASE_URL}/patients`, { patient: { name, cpf, payer_attributes: { name: payer_name, cpf: payer_cpf } } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "token-type": localStorage.getItem("token-type"),
          "expiry": localStorage.getItem("expiry"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"

        }
      })
      .then((response) => {
        goToPatients(navigate)
      })
      .catch((erro) => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      }
      )
  }
  const EditPatient = () => {
    let id = UseQuery().get("id")
    let url = `${process.env.REACT_APP_BASE_URL}/patients/${id}`
    let body = ""
    if (checked) {
      body = { patient: { name, cpf, payer_attributes: { name: payer_name, cpf: payer_cpf } } }
    } else {
      body = { patient: { name, cpf } }
    }
    axios.put(url, body,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        goToPatients(navigate)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }


  const Show = () => {
    let id = UseQuery().get("id")
    if (id) {
      let url = `${process.env.REACT_APP_BASE_URL}/patients/${id}`

      axios.get(url,
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "expiry": localStorage.getItem("expiry"),
            "token-type": localStorage.getItem("token-type"),
            "uid": localStorage.getItem("uid"),
            "Content-Type": "application/json"
          }
        })
        .then(response => {

          setName(response.data.name)
          setCpf(response.data.cpf)
          if (response.data.payer !== null) {
            setChecked(true)
            setPayerName(response.data.payer.name)
            setPayer_cpf(response.data.payer.cpf)
          }

        })
        .catch(erro => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
          if (erro.response.status === 401) {
            goToLogin(navigate)
          }
        })
    }
  }

  useEffect(() => {
    Show()

  }, [])

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Cadastrar Paciente</Typography>
          <Divider />
          <form>
            <Typography sx={{ paddingTop: 1 }} variant="h3">Dados</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    name={"name"}
                    required
                    id="outlined-required"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    label={"Nome"}
                    type={"name"}
                    fullWidth
                    sx={{
                      mb: 2,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <InputMask
                    name={"cpf"}
                    id="outlined-required"
                    onChange={(e) => setCpf(e.target.value)}
                    value={cpf}
                    type={"text"}
                    mask="999.999.999-99"
                    disabled={false}
                    fullWidth

                  >
                    {() => <TextField fullWidth label={"CPF"} />}
                  </InputMask>
                </Grid>
              </Grid>
            </CardContent>
            <Typography variant="h3">Grupo</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <FormControlLabel
                control={<Switch checked={checked} onChange={handleChange} />}
                label="Possui pagador?"
              />
              <Box sx={{ display: 'flex' }}>

                <Grow in={checked}>{icon}</Grow>

              </Box>
            </CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Box>
                <Button onClick={save} variant="contained" color="success" startIcon={<AddIcon />}>
                  Salvar
                </Button>
                <Button onClick={() => goToPatients(navigate)} variant="outlined" startIcon={<ArrowBackIosIcon />}>
                  Voltar
                </Button>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PatientRecord;